import classes from './PageHeader.module.scss';

const PageHeader = (props) => {
    if (!props) return null;
    const data = props[0];
    return (
        <div className={classes.oPageHeader}>
            <div className={`container`}>
                <div className={`row`}>
                    {data.site_description ? (
                        <div className={`col`}>
                            <h1 className={`${classes.aBlockTitle} fntH1`}>{data.site_header}</h1>
                            <p className={`${classes.aBlockText} fnt24`}>{data.site_description}</p>
                        </div>
                    ) : (
                        <div className={`col`}>
                            <h1 className={`${classes.aBlockTitle} ${classes.hasAccent} fntH1`}>
                                {data.site_header}
                            </h1>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default PageHeader;
